<app-side-nav-container [menu]="navMenu" [userClaims]="userClaims"></app-side-nav-container>
